/**
 * Authenticated Layout
 *
 * Layout route for all authenticated pages. Wraps children with
 * ProtectedRoute to enforce authentication.
 *
 * Uses ProtectedRoute to redirect unauthenticated users to sign-in.
 */

import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ProtectedRoute } from '@lib/auth'

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
})

function AuthenticatedLayout() {
  return (
    <ProtectedRoute>
      <Outlet />
    </ProtectedRoute>
  )
}
